import { useSearchParams } from 'react-router';

import NonParamFilterButton from 'DesignSystem/features/filters/ToolbarFilterNonParam';
import SingleSelectFilterButton from 'DesignSystem/features/filters/ToolbarFilterSingleSelect';
import track from 'features/Analytics/track';
import {
  useClinicalLocationGroupsEnabled,
  useClinicalLocationSensitiveContextEnabled,
} from 'pages/disruption/api/selectors';
import {
  clinicalLocationSearchKeywords,
  useClinicalLocationGroupOptions,
  useClinicalLocationsOptions,
} from 'pages/disruption/atoms/filters';
import { PERIOD_OPTIONS } from 'pages/disruption/components/period-select';
import { validateForDaysCalculated } from 'pages/disruption/queue/utils';

export default function EventItemsFilters() {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasClinicalLocation = useClinicalLocationSensitiveContextEnabled();
  const hasClinicalLocationGroups = useClinicalLocationGroupsEnabled();
  const clinicalLocationsOptions = useClinicalLocationsOptions();
  const groupOptions = useClinicalLocationGroupOptions();

  const selectedLocation = searchParams.get('for_clinical_location') || undefined;
  const selectedGroup = searchParams.get('for_clinical_location_group') || undefined;
  const currentPeriod = validateForDaysCalculated(searchParams.get('for_days_calculated'));

  function selectGroup(selected: string) {
    const next = new URLSearchParams(searchParams);
    if (selected.length === 0) {
      track.drm.changeClinicalLocationGroup('All', 'Detail');
      next.delete('for_clinical_location_group');
    } else {
      track.drm.changeClinicalLocationGroup(selected, 'Detail');
      next.set('for_clinical_location_group', selected);
      next.delete('for_clinical_location');
    }
    setSearchParams(next);
  }

  function selectLocation(selected: string) {
    const next = new URLSearchParams(searchParams);
    if (selected.length === 0) {
      track.drm.changeClinicalLocation('All', 'Detail');
      next.delete('for_clinical_location');
    } else {
      next.set('for_clinical_location', selected);
      track.drm.changeClinicalLocation(selected, 'Detail');
    }
    setSearchParams(next);
  }

  function selectPeriod(value: string) {
    const next = new URLSearchParams(searchParams);
    next.set('for_days_calculated', value);
    track.drm.changePeriod(value, 'Detail');
    setSearchParams(next);
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {hasClinicalLocationGroups ? (
        <SingleSelectFilterButton
          options={groupOptions}
          attribute="for_clinical_location_group"
          label="Group"
          selected={selectedGroup}
          onSelect={selectGroup}
          persisted
          inputPlaceholder="Search"
          arrowIcon
          testId="filter-button-Group"
        />
      ) : null}
      {hasClinicalLocation ? (
        <SingleSelectFilterButton
          options={clinicalLocationsOptions}
          attribute="for_clinical_location"
          label="Location"
          selected={selectedLocation}
          onSelect={selectLocation}
          persisted
          inputPlaceholder="Search"
          disabled={!!selectedGroup}
          arrowIcon
          testId="filter-button-Location"
          getSearchKeywords={clinicalLocationSearchKeywords}
        />
      ) : null}
      <NonParamFilterButton
        label="Period"
        selected={String(currentPeriod)}
        onSelect={selectPeriod}
        options={PERIOD_OPTIONS}
        testId="filter-button-Period"
      />
    </div>
  );
}
